import { OperadorasActions } from '@gestor-web/@core/store/actions';
import { Operadora, OperadoraModulo, OperadoraParametros, VinculoUsuarioOperadora } from '@gestor-web/@core/api/ords/model';
// import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { buildModulosAtivosSet } from '@gestor-web/app/shared/utils/modulos';

export const featureKey = 'operadoras';

export interface State {
  operadorasGeral: Operadora[];
  operadorasCliente: Operadora[];
  operadorasWorkspace: Operadora[] | VinculoUsuarioOperadora[];
  operadorasGeralMap: { [key: string]: Operadora };
  operadorasClienteMap: { [key: string]: Operadora };
  operadorasWorkspaceMap: { [key: string]: Operadora | VinculoUsuarioOperadora };
  selectedOperadoraDadosSetor: Operadora | null;
  selectedOperadoraWorkspace: Operadora | VinculoUsuarioOperadora | null;
  workspaceParams: OperadoraParametros | null;
  workspaceNotFound: boolean;
  modulos: OperadoraModulo[];
  modulosAtivos: string[];
  loaded: boolean;
}

export const initialState: State = {
  operadorasGeral: [],
  operadorasCliente: [],
  operadorasWorkspace: [],
  operadorasGeralMap: {},
  operadorasClienteMap: {},
  operadorasWorkspaceMap: {},
  selectedOperadoraDadosSetor: null,
  selectedOperadoraWorkspace: null,
  workspaceParams: null,
  workspaceNotFound: false,
  modulos: [],
  modulosAtivos: [],
  loaded: false,
};

export const reducer = createReducer(
  initialState,

  on(OperadorasActions.getOperadorasSuccess, (state, { operadorasGeral, operadorasClientes, operadorasWorkspace }) => {
    const operadorasGeralMap = operadorasGeral.reduce((map, op) => {
      map[op.cd_registro_ans] = op;
      return map;
    }, {});
    const operadorasClientesMap = operadorasClientes.reduce((map, op) => {
      map[op.cd_registro_ans] = op;
      return map;
    }, {});
    const operadorasWorkspaceMap: { [key: string]: Operadora | VinculoUsuarioOperadora } = {};
    for (const op of operadorasWorkspace) {
      operadorasWorkspaceMap[op.cd_registro_ans] = op;
    }
    return {
      ...state,
      operadorasGeral,
      operadorasClientes,
      operadorasWorkspace,
      operadorasGeralMap,
      operadorasClientesMap,
      operadorasWorkspaceMap,
      loaded: true,
    };
  }),

  on(OperadorasActions.changeSelectedOperadoraDadosSetorSuccess, (state, { operadora }) => {
    return { ...state, selectedOperadoraDadosSetor: operadora };
  }),

  on(OperadorasActions.changeSelectedOperadoraWorkspaceSuccess, (state, { operadora, params, modulos }) => {
    const modulosAtivos = Array.from(buildModulosAtivosSet(modulos));

    return {
      ...state,
      selectedOperadoraWorkspace: operadora,
      workspaceParams: params,
      workspaceNotFound: false,
      modulos,
      modulosAtivos,
    };
  }),

  on(OperadorasActions.changeSelectedOperadoraWorkspaceFailed, state => {
    return {
      ...state,
      selectedOperadoraWorkspace: null,
      workspaceParams: null,
      workspaceNotFound: true,
      modulos: [],
      modulosAtivos: [],
    };
  }),

  on(OperadorasActions.changeWorkspaceParams, (state, { partialParams }) => {
    const workspaceParams = { ...state.workspaceParams, ...partialParams };
    return {
      ...state,
      workspaceParams,
    };
  }),

  on(OperadorasActions.clearNotFound, state => {
    return {
      ...state,
      workspaceNotFound: false,
    };
  }),
);
